import ProjectCard from "./ProjectCard";
import ProjectImage1 from "../assets/Projects/1.jpg";
import ProjectImage2 from "../assets/Projects/2.png";
import ProjectImage3 from "../assets/Projects/3.jpg";
import ProjectImage4 from "../assets/Projects/4.jpg";
import "./Project.css";

const projects = [
  {
    title: "Nsut Magnet",
    description: "Magnet is an innovative platform designed to connect people, ideas, and opportunities. Our journey has been driven by passion, technology, and a commitment to excellence.",
    status: "completed",
    link: "https://nsutmagnet.tech/",
    image: ProjectImage1
  },
  {
    title: "Ionic Engine",
    description: "A mobile app using AR for seamless indoor campus navigation.",
    status: "ongoing",
    link: "#",
    image: ProjectImage2
  },
   {
    title: "RC Plain",
    description: "A mobile app using AR for seamless indoor campus navigation.",
    status: "ongoing",
    link: "#",
    image: ProjectImage3
  },
   {
    title: "Convertable Drone",
    description: "A mobile app using AR for seamless indoor campus navigation.",
    status: "active",
    link: "#",
    image: ProjectImage4
  }
];

function Project() {
  return (
    <div className="project-bg">
      <div className="newcontainer">
        <h1 style={{ textAlign: "center", color: "#3a86ff", marginBottom: "32px" }}>Projects</h1>
        <div className="project-list">
          {projects.map((project, idx) => (
            <ProjectCard project={project} key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Project;
